<template>
	<div class="policylibrary qualityenterprise" >
		<leftnav class="fl" :mkcode="(curWebsite.type == 5 || curWebsite.type == 6)? 'T':'B'" itemcode="B-CYZC" ></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<!-- <div class="right_boxtitle">
						<span class="fl right_title"></span>
						<div class="fl search-box nz-search-box">
							<input type="text" placeholder="" class="" v-model="kw" @keydown="searchenter" />
							<button class="" @click="getlist()">查询</button>
						</div>
					</div> -->
					<div class="right_boxtitle">
						<span class="fl right_title">政策库</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">政策库</span>
							<input type="text" placeholder="请输入政策关键词" class="search-input" v-model="kw"	@keydown="searchenter" />
							<button class="search-btn" @click="getlist()">查询</button>
						</div>
					</div> 
					<!-- <div class="mapserch_mapbox" style="position: fixed;width:100%;height:100%;left:40px;top:0;border:1px solid #f60;z-index:9999;">
							<iframe class="mapserch_map1" style="width:100%;height:100%;" :src="mapurl"></iframe>
						</div> -->
					<div class="opport-screen-list1">
							<div class="spage-searchbox "> 
								 <dl class="opport-screen bdbe"  >
								 	<dt class="fl">政策利弊</dt>
								 	<dd class="fl">
											<!-- <el-radio v-model="radio" :label="1">利好</el-radio>
											<el-radio v-model="radio" :label="2">利空</el-radio>
											<el-radio v-model="radio" :label="0">不限</el-radio> -->
											<span @click="radiochoose(0)" :class="radioid == 0 ?'a-screen current':'a-screen'">不限</span>
											<span @click="radiochoose(1)" :class="radioid == 1 ?'a-screen current':'a-screen'">利好</span>
											<span @click="radiochoose(2)" :class="radioid == 2 ?'a-screen current':'a-screen'">利空</span>
											<video-teaching :type="2" ></video-teaching>
								 	</dd>
										
								 </dl>
									<!-- <dl class="opport-screen bdbe">
										<dt class="fl">时间范围</dt>
										<dd class="fl">
											<el-date-picker v-model="value1" type="date" placeholder="选择日期"	@change="dateFormat(1,value1)"> </el-date-picker><span class="aaa">至</span>
											<el-date-picker v-model="value" type="date" placeholder="选择日期" @change="dateFormat(2,value)"></el-date-picker> 
										</dd>
									</dl>  -->
					<dl class="opport-screen bdbe">
						<dt class="fl">产业分类</dt>
						<dd class="fl screenop">
							<span @click="chooseNotion(1,'a',{lable:'全部',value:0,children:[]})" :class="notionCode == 0 ?'a-screen current':'a-screen'">全部</span>
							<span v-for="(item,index) in notionlist" v-show="item.label.indexOf('制造业')>-1" :class="chooseNotionlist[0] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(1,'a',item)">{{item.label}}</span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist1.length>0">
						<dt class="fl titleop">一级产业</dt>
						<dd class="fl">
							<span @click="chooseNotion(2,'all',fenkd)" :class="chooseNotionlist[1]==0 ?'a-screen current':'a-screen'">全部</span>
							<span v-for="(item,index) in notionlist1" :class="chooseNotionlist[1] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(2,'a',item)">{{item.label}}</span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
						<dt class="fl titleop">二级细分</dt>
						<dd class="fl">
							<span @click="chooseNotion(3,'all',fenkd)" :class="chooseNotionlist[2]==0 ?'a-screen current':'a-screen'">全部</span>
							<span v-for="(item,index) in notionlist2" :class="chooseNotionlist[2] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(3,'a',item)">{{item.label}}</span>
						</dd>
					</dl> 
				</div>
							
						</div> 
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">{{tips}}<span class="searchnum orangefont">{{total}}</span>条
						</p>
					</div>
					<div class="enterprise_list_box">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>发布时间</th>
								<th class="  policy_parkname1th">政策名称</th>
								<th>利弊</th>
								<!-- <th>影响力</th> -->
							</tr>
							<tr v-for="(item,i) in pagelist">
								<td>{{item.publishTime}}</td>
						 	<td class="policy_parkname" @click="routerlinkid('/news',item.id,1)">
									{{item.title}}</td>
								<td>
									<span v-if="item.good==1">利好</span>
									<span v-if="item.good==2">利空</span>
								</td>
								<!-- 	<td><span :class="item.good==1?'stargrade1 redstargrade':'stargrade1 greenstargrade'" ><i class="" v-for="list in item.star"></i></span> </td> -->
								<!-- good=1 利好红色，good =2 利空 绿色-->
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
						<!-- <p><input type="number" v-model="jumppage"/><span @click="aa()">跳转</span></p> -->
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'index',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite: this.$api.getWebsiteType(),
				title: "产业政策",mapurl:"",
				notionCode:'',chooseNotionlist:[0,0,0,0,0],	fenkd:{children:[]}, 
				notionlist1:[],
				notionlist2:[],
				notionlist3:[],
				notionlist4:[],
				notionlist5:[],
				notionlist6:[], 
				radioid:0,
				islogin: false,
				userdata: {},
				radio: 0,
				radio2: 5,
				value1: '',
				date: '', //日期选择 
				pagelist: [],
				options: [],
				value: '',
				// page: 1,  //显示的是哪一页
				// haspage:true,//是否还有下一页
				// pageSize: 20, //每一页显示的数据条数
				// total: 0, //记录总数
				// totalPage:1,
				// maxPage:10,  //最大页数
				kw: '', //搜索关键词
				tips: '截止目前产业大脑已收纳产业政策',
				//-------------------------------
				msg: "产业机会",
				showscreen: true,
				notiontype: '',
				searchtype: 1,
				searchtype1: 1,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "",
				notionbtn: false,
				notionlist: [{
					label: "先进制造业",
					value: "A"
				}, ], 
				options1: {},
				options2: {},
				options3: {},
				flag: false,
				cascadervalue: "",
				usernotionlistsave: [], //用户选择的概念列表存储
				usernotionlist: [], //用户选择的概念列表
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数
				jumppage: '', //跳转页数
				provincelist: [],
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: [],
				citydata: [],
				countydata: [],
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				initialTagdata1: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				searchtagdata: [],
				enterpristlist: [],
				industrydata: [],
				usertaglist: [],
				capitalid: 0,
				typeid1: 0,
				typeid2: 0,
				typeid3: 0,
				typeid4: 0,
				typeid5: 0,
				typeid6: 0,
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序
				orderType1: 1, //排序方式 0 降序 1 升序
				orderType2: 0, //排序方式 0 降序 1 升序 
			}
		},
	 
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() {
			
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			this.userdata = this.getuserinformain();
			this.getCurrentTime();
		this.mapurl = this.$api.cyl.govementchart.mapserch() + '?token=' + this.userdata.token + "&date=" + this.time;
			// this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
			// 	// console.log(res.data)
			// 	if(res.data.success){  
			// 		console.log(res.data)
			// 	 _this.provincedata=res.data.list; 
			// 	}else{ 
			// 		
			// 	} 
			// }).catch(function (error) { 
			// 	// 请求失败处理 console.log(error);
			// });
			// this.getocnapidoctaglist(2);

		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5"; 
			
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			} 
			// this.getlist(0);
			//--------------------------------------
			var _this = this;
			// this.getuserinfor();  
			// this.searchtype = 1;
			// this.searchtype1 = 1;
			// _this.notionlist=NotionTree; 
			//三大产业概念数据
			this.$axios.get(this.$api.tag.notion.list() + '?level=5', {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) {
				// console.log(res.data)
				if (res.data.success) {
					console.log(res.data.list)
					_this.notionlist = res.data.list;
					_this.options1 = res.data.list[0].children;
					_this.options2 = res.data.list[1].children;
					_this.options3 = res.data.list[2].children;
					_this.flag = true;
					// _this.notionlist=res.data.list;  
				} else {
					
				}
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
			this.getlist(); 
		},
		methods: {
			getCurrentTime() {
				//获取当前时间
				var _this = this;
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();
				let hh = new Date().getHours();
				let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
				// 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss; 
				this.time = yy + '-' + mm + '-' + dd + ' ';
			},
			//利好利空选择
			radiochoose(id){
				this.radioid=id;
				this.getlist();
			},
			//概念单选 层级显示
			chooseNotion(step,type,data){  
					if(type == 'all'){
						this.notionCode=this.chooseNotionlist[step-2];
						this.chooseNotionlist[step-1]='0'; 
				}else{
					this.chooseNotionlist[step-1]=data.value;
					// this.chooseNotionlist[step]='0';
					for(var i=0;i<this.chooseNotionlist.length;i++){
						if(i>step-1){
							this.chooseNotionlist[i]=0;
						}
					}
					this.notionCode=data.value;  
					} 
				if(data.children!=null){
					if(step == 1 ){
						this.notionlist1=data.children.filter(list=>{
							return list.label!='环保';
						});
						// console.log(this.notionlist1)
						this.notionlist2=[];this.notionlist3=[];this.notionlist4=[];
					}else if(step == 2){
						this.notionlist2=data.children;
						this.notionlist3=[];this.notionlist4=[];
					}else if(step == 3){
						this.notionlist3=data.children;this.notionlist4=[];
					}else if(step == 4){
						this.notionlist4=data.children;this.notionlist5=[];
					}else if(step == 5){
						this.notionlist5=data.children;
					} 
				}
			console.log(this.chooseNotionlist,this.chooseNotionlist[step-1],step);
				this.getlist();
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.getlist();
				}
			},
			// emty() { //清空已选概念数据
			// 	this.usernotionlist = [];
			// 	this.usernotionlistsave = []; 
			// 	this.$refs['cascaderinput1'].$refs.panel.clearCheckedNodes(); //取消勾选当前选中的所有节点
			// 	this.$refs['cascaderinput2'].$refs.panel.clearCheckedNodes(); //取消勾选当前选中的所有节点
			// 	this.$refs['cascaderinput3'].$refs.panel.clearCheckedNodes(); //取消勾选当前选中的所有节点
			// },
			restfun() { //筛选重置 不启用了
				this.radio = 0;
				this.radio2 = 5; 
				this.value = '';
				this.value1 = ''; 
				this.kw = ''; 
				this.notionCode =0;
				this.chooseNotionlist=[0,0,0,0,0,0];
				this.notionlist1=[];
				this.notionlist2=[];
				this.notionlist3=[];
				// this.emty();
				this.getlist()
			},
			getlist(pages) {
				// this.usernotionlist=this.usernotionlistsave;
				// var notionja = this.jsondouhao('notionList', this.usernotionlistsave); 
				// this.bus.$emit('loading', true);
				var ajpage = 1;
				if (pages) {
					ajpage = pages;
				}
				this.page = ajpage;
				var _this = this,
					dnotion = [];
					var notionja =this.splicing('notionList',this.notionCode);
					var kwja =this.splicing('kw',this.kw); 
					var goodjia = this.splicing('good',this.radioid);
					var dateja = this.splicing('date',this.value);
				this.bus.$emit('loading', true);
				var ajaxurl = this.$api.cyl.news.list() + "?type=2&bigClass=30008" + '&page=' + ajpage+notionja+kwja+goodjia+dateja; 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("政策链", ajaxurl,res);
					if (res.data.code < 1) { 
						// console.log('zhengcejia',notionja);
						_this.pagelist = res.data.list;
						_this.bus.$emit('loading', false);
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.maxPage = res.data.totalPage;
						_this.haspage = res.data.list.length == res.data.pageSize;
						if (type == 0) {
							for (var i = 0; i < _this.pagelist.length; i++) {
								dnotion.push({
									notion: _this.pagelist[i].notion,
									notionCode: _this.pagelist[i].notionCode
								});
						} 
						}

					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},

			//格式化日期 （时间戳）
			dateFormat(type, date) {
				console.log(type, date);
				console.log('vafaf', this.value1, this.value);
				var M = date.getMonth() + 1;
				M = M < 10 ? ('0' + M) : M;
				var y = date.getFullYear();
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
				var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
				var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
				var time = y + '-' + M + '-' + d;
				console.log('tiem', time);
				if (type == 1) {
					this.value1 = time;
				}
				if (type == 2) {
					this.value = time;
				}
			},
			pageHandler: function(page) {
				this.notioneditbtn = false;
				this.getlist(page);
			},
			// 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
 
	 


			//-------------------------------------

 
		 
	 
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			}, 
			//获取用户信息
			getuserinfor() {
				let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				}
				// console.log(this.userdata.tagText,this.userdata.tag);
				// this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
				// this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion);
			}, 
			//省份城市选择 
		 
			//字符串拼接
			jsondouhao(name, data) {
				var notionja = "",
					douhao = '%2C';
				if (data.length > 0) {
					if (name == "kw") {
						notionja = data;
					} else {
						for (var i = 0; i < data.length; i++) {
							if (i == data.length - 1) {
								douhao = '';
							}
							if (name == 'tag') {
								notionja += data[i] + douhao;
							} else if (name == "notion") {
								notionja += data[i].id + douhao;
							} else if (name == "notionList") {
								notionja += data[i].id + douhao;
							}
						}
					}
					notionja = '&' + name + '=' + notionja;
					var notionja3 = notionja;
				}
				// console.log('notionja',notionja);
				return notionja3;
			}, 
		},
	}
</script>

<style>
</style>
